module.exports = "/_next/static/images/62ad7eb935c71c8b1120a3ccc03f1a4d-steps-mobile.jpg";